import MenuBar from "../Component/MenuBar";
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import { NavLink } from "react-router-dom";

const GaneshChaturthi = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <section className="page-banner">
                <div className="image-layer" style={{ backgroundImage: 'url(https://sevastorage.blob.core.windows.net/seva-blob/Yugalkunj_website/background/bg-page-title-2.jpg)' }}></div>
                <div className="auto-container">
                    <h1>Ganesh Chaturthi Satsang &amp; Celebrations</h1>
                </div>
                <div className="breadcrumb-box">
                    <div className="auto-container">
                        <ul className="bread-crumb clearfix">
                            <li><NavLink to="/USA/Home">Home</NavLink></li>
                            <li className="active">Ganesh Chaturthi Satsang &amp; Celebrations</li>
                        </ul>
                    </div>
                </div>
            </section>

            <div className="container" style={{ paddingBottom: "40px" }}>

                {/* Heading */}
                <div className="auto-container">
                    <div className="centered">
                        <hr />
                        <h3>Ganesh Chaturthi Satsang &amp; Celebrations</h3>
                        <h4 className="text-center" style={{ color: "#666", marginTop: "8px" }}>
                            Monday, September 14th &nbsp;|&nbsp; 7:00 PM – 8:30 PM
                        </h4>
                        <h5 className="text-center" style={{ color: "#888", marginTop: "5px" }}>
                            Yugal Kunj &nbsp;·&nbsp; 2769 Duluth Hwy, Duluth, GA 30096
                        </h5>
                        <p className="text-center" style={{ marginTop: "12px", fontStyle: "italic", color: "#e67e22", fontSize: "16px" }}>
                            Join us for a devotional evening of Ganesh Abhishek, Aarti, youth stotram chanting, Modak Prasad &amp; Dinner Prasad.
                        </p>
                        <hr />
                    </div>
                </div>

                {/* Flyer */}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Ganesh Chaturthi 2026 – Event Flyer</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="widget-49">
                                    <figure className="image">
                                        <img
                                            src="https://yugalkunj.org/images/Ganesh_Chaturth.png"
                                            alt="Ganesh Chaturthi Satsang & Celebrations 2026"
                                            style={{ width: "100%" }}
                                        />
                                        <a
                                            href="https://yugalkunj.org/images/Ganesh_Chaturth.png"
                                            className="lightbox-image overlay"
                                            data-fancybox="gallery-ganesh"
                                        ></a>
                                    </figure>
                                    <br />
                                    <div className="widget-49-meeting-action">
                                        <a
                                            href="https://yugalkunj.org/images/Ganesh_Chaturth.png"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-sm btn-flash-border-primary"
                                        >
                                            View Flyer
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Highlights */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Highlights</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <ul className="satsang_list">
                                        <li><strong>Ganesh Abhishek</strong></li>
                                        <li><strong>Ganesh Aarti</strong></li>
                                        <li><strong>Ganesh Stotram Chanting by Youth</strong></li>
                                        <li><strong>Modak Prasad</strong></li>
                                        <li><strong>Dinner Prasad</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Event Details */}
                <hr />
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Event Details</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title orange-border">
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '15px' }}>
                                        <tbody>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22', width: '140px' }}>Event</td>
                                                <td style={{ padding: '10px 12px' }}>Ganesh Chaturthi Satsang &amp; Celebrations</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Date</td>
                                                <td style={{ padding: '10px 12px' }}>Monday, September 14th, 2026</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Time</td>
                                                <td style={{ padding: '10px 12px' }}>7:00 PM – 8:30 PM</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee', background: '#fafafa' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Venue</td>
                                                <td style={{ padding: '10px 12px' }}>Yugal Kunj</td>
                                            </tr>
                                            <tr style={{ borderBottom: '1px solid #eee' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Address</td>
                                                <td style={{ padding: '10px 12px' }}>2769 Duluth Hwy, Duluth, GA 30096</td>
                                            </tr>
                                            <tr style={{ background: '#fff8e1' }}>
                                                <td style={{ padding: '10px 12px', fontWeight: 'bold', color: '#e67e22' }}>Welcome</td>
                                                <td style={{ padding: '10px 12px' }}>All are Welcome</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Location */}
                <hr />
                <div className="row" style={{ marginBottom: "30px" }}>
                    <div className="col-lg-12">
                        <div className="card card-margin">
                            <div className="card-header no-border">
                                <h5 className="card-title">Location</h5>
                            </div>
                            <div className="card-body pt-0">
                                <div className="inner_heading_title purple-border" style={{ paddingLeft: "20px" }}>
                                    <h4>Yugal Kunj</h4>
                                    <p>2769 Duluth Hwy, Duluth, GA 30096</p>
                                    <p><strong>Date:</strong> Monday, September 14th, 2026</p>
                                    <p><strong>Time:</strong> 7:00 PM – 8:30 PM</p>
                                    <br />
                                    <a
                                        href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-flash-border-primary"
                                    >
                                        Open in Google Maps
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default GaneshChaturthi;
